import React from 'react';

export class WordChooseBtn extends React.Component {
	showMessage(e) {
		if (e.target.className === 'asterisk') {
			e.target.firstChild.style.display = 'block';
		}
	}
	hideMessage(e) {
		if (e.target.className === 'asterisk') {
			e.target.firstChild.style.display = 'none';
		}
	}
	render() {
        return (
		    <div 
		        key={this.props.index} 
		        id={this.props.label} 
		        className={this.props.selected ? "word-btn on" : "word-btn up"}
        		style={{backgroundImage: `url(./images/sections/words/chars/${this.props.selected ? `on` : `up`}/` + this.props.label + `.svg)`}}
		    >
		    	<div className="btn" id={this.props.label} onClick={this.props.onClick}></div>
		    	{this.props.asterisk && <div id={`asterisk-` + this.props.label} className="asterisk" onMouseDown={this.showMessage} onMouseUp={this.hideMessage} onMouseOut={this.hideMessage} onTouchStart={this.showMessage} onTouchEnd={this.hideMessage}><div className="message"></div></div>}
		    </div>
    	);
    }
};

export default WordChooseBtn;



// WEBPACK FOOTER //
// ./src/components/sections/words/WordChooseBtn.js